// extracted by mini-css-extract-plugin
export var banner = "_i1-0";
export var closeButton = "_i1-2";
export var greenCheckmark = "_i1-3";
export var hereLink = "_i1-4";
export var titleIcon = "_i1-1";